var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 rounded",attrs:{"items":_vm.gruops,"headers":_vm.gruopsHeader,"disable-pagination":true,"hide-default-footer":true,"no-data-text":_vm.tableText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }